import React from 'react';
import PropTypes from 'prop-types';

import '../style.scss';

const ClientBlock = ({ width, minSize, invisible, scroll, headerButtons, children, title }) => {
  const style = {
    width,
    overflowY: scroll ? 'auto' : 'inherit',
    height: minSize,
    backgroundColor: invisible ? 'transparent' : '#fff',
    border: invisible ? 'none' : '1px solid #E5E5E5',
  };

  return (
    <div className="client-block">
      <div className="client-block-title">{title} <div className="buttons">{headerButtons}</div></div>

      <div className={`client-block-content ${scroll && 'scrollable'}`} style={style}>
        {children}
      </div>
    </div>
  );
};

ClientBlock.propTypes = {
  width: PropTypes.string,
  scroll: PropTypes.bool,
  minSize: PropTypes.string,
  invisible: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  headerButtons: PropTypes.node
};

ClientBlock.defaultProps = {
  width: 'auto',
  minSize: 'auto',
  scroll: false,
  invisible: false,
  children: '',
  headerButtons: ''
};

export { ClientBlock };
